import styled from 'styled-components'
import css from '@styled-system/css'
import { Badge } from '@careguide/badge'

export const HeaderLink = styled.a`
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.3s ease-out;

  > ${Badge} {
    margin-left: 5px;
  }

  ${css({
    color: 'gray.6',
    ':hover': {
      color: 'primary.600',
    },
  })};
`
